// round rounds the supplied time to the nearest 15 minute interval.
export function roundInterval(date: Date): Date {
  let minutes = date.getMinutes();
  if (minutes % 15 !== 0) {
    minutes += 15 - (minutes % 15);
  }
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), minutes);
}
